import { env } from '../env'

window.API_GATEWAY_URL = env.VITE_URL_API_GATEWAY
window.xBufferClientId = env.VITE_X_BUFFER_CLIENT_ID
const appShellScript = document.createElement('script')
appShellScript.src = env.VITE_NAVIGATOR_URL
document.body.prepend(appShellScript)
